/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Svg_TitleInputs */

const en_map_svg_title = /** @type {(inputs: Map_Svg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The map of Nexxt`)
};

/**
* | output |
* | --- |
* | "The map of Nexxt" |
*
* @param {Map_Svg_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const map_svg_title = /** @type {((inputs?: Map_Svg_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Svg_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_map_svg_title(inputs)
});